<template>
  <a-modal
    title="操作日志"
    width="750px"
    :visible="visible"
    okText="确认"
    :destroyOnClose="true"
    @cancel="close"
  >
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="logList"
      :scroll="{
        y: '680px'
      }"
      :pagination="false"
      :loading="logLoading"
      row-key="id"
    ></a-table>
    <template slot="footer">
      <a-button type="primary" @click="close">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'OperationLogModel',
  data() {
    return {
      visible: false,
      columns: [
        { title: '操作人员', width: 100, align: 'center', dataIndex: 'createName' },
        { title: '操作时间', width: 160, align: 'center', dataIndex: 'createTime' },
        { title: '操作内容', dataIndex: 'logInfo' }
      ]
    }
  },
  props: {
    logLoading: {
      type: Boolean,
      default: false
    },
    logList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
      this.$emit('closeLog')
    }
  }
}
</script>

<style scoped>

</style>
